// extracted by mini-css-extract-plugin
export default {"languagesLineContainer":"languagesLineContainer__mjjaf","selected":"selected__KpC0a"};